/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Upload_BlogsInputs */

const en_features_upload_blogs = /** @type {(inputs: Features_Upload_BlogsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blogs`)
};

const es_features_upload_blogs = /** @type {(inputs: Features_Upload_BlogsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blogs`)
};

/**
* | output |
* | --- |
* | "Blogs" |
*
* @param {Features_Upload_BlogsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const features_upload_blogs = /** @type {((inputs?: Features_Upload_BlogsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Upload_BlogsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_features_upload_blogs(inputs)
	return en_features_upload_blogs(inputs)
});